import styled from 'styled-components';
import Icon from '../ui/Icon';
import ProgressBar from '../ui/Progress/ProgressBar';
import Separator, { SeparatorColor, SeparatorSize } from '../ui/Separator';
import Tooltip from '../ui/Tooltip/Tooltip';
import { stores, useStore } from '../utils/store';
import Skill from './Skills/Skill';


export default function SkillsPage() {
    const [skills,] = useStore(stores.skills);
    return (
        <Wrapper>
            <div className="stats-header">
                <div className='profile'>
                    <div className='avatar'>
                        <Icon icon='stats' size={40} />
                        {/* <div className='lvl'>Lvl. 1</div> */}
                    </div>
                    <div className='username'>$USERNAME</div>
                    <div className='title'>$USER_RANK</div>
                    <div className='progress'>
                        <ProgressBar value={20}></ProgressBar>
                    </div>
                </div>
                <Tooltip title='Amount of XP gained today'>
                    <div className='stats-today-total'>
                        <div className='stats-today-total-title'>Today XP</div>
                        <div className='stats-today-total-xp'>0.0</div>
                    </div>
                </Tooltip>

            </div>

            {/* //Maybe add stuff like current streak, total hours, total xp && In the bottom today xp gained */}
            {/* <Separator offset='45%' spacing={10} color={SeparatorColor.PRIMARY} size={SeparatorSize.LARGE}></Separator> */}
            <div className='stats-body'>
                <div className='stats-skills'>
                    {skills.map((skill) => <Skill key={skill.id} skill={skill}></Skill>)}
                </div>
                {/* <Separator offset='45%' spacing={10} color={SeparatorColor.SECONDARY} size={SeparatorSize.LARGE}></Separator> */}

            </div>

            <div className='stats-graph'>Activity Graph</div>
            <div className='stats-history'>Log/History</div>

        </Wrapper>
    )
}

const Wrapper = styled.div`

    .stats-header {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: flex-end;
    }

    .stats-today-total {
        background-color: ${props => props.theme.foregroundColor};
        border-radius: ${props => props.theme.borderRadius};
        padding: 10px 20px;
        min-width: 100px;

        .stats-today-total-title {
            font-size: 11px;
            color: #dddddd;
            margin-bottom: 2px;
            text-align: center;
        }

        .stats-today-total-xp {
            font-size: 14px;
            text-align: center;
        }
    }

    .profile {
        background-color: ${props => props.theme.foregroundColor};
        padding: 10px;
        max-width: 300px;
        flex-grow: 1;
        border-radius: ${props => props.theme.borderRadius};

        display: grid;

        grid-template-columns: min-content auto;
        grid-template-rows: 20px 14px 20px;

        .avatar {
            width: 54px;
            height: 54px;
            border-radius: 50%;
            grid-row: 1/3;
            grid-column: 1;

            display: grid;
            align-content: center;
            justify-content: center;

            .lvl {
                font-size: 12px;
                text-align: center;
                color: #dddddd;
                margin-top: 4px;
            }
        }

        .username {
            text-align: center;
            grid-row: 1;
            grid-column: 2;
        }

        .title {
            font-size: 10px;
            color: #ffffffcc;
            text-align: center;
            grid-row: 2;
            grid-column: 2;
        }

        .progress {
            grid-row: 3;
            grid-column: 2;
            display: flex;
            align-items: center;
            padding: 0 20px;

            .progress-bar {
                width: 100%;
            }
        }
    }


    .stats-body {
        background-color: ${props => props.theme.foregroundColor};
        border-radius: ${props => props.theme.borderRadius};

        padding: 4px;
        margin: 10px 0;
    }

    .stats-skills {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;

        
        gap: 4px;

        @media(max-width: 650px) {
            grid-template-columns: 1fr 1fr 1fr;
        }

        @media(max-width: 490px) {
            grid-template-columns: 1fr 1fr;
        } 
    }

    .stats-graph {
        background-color: ${props => props.theme.foregroundColor};
        border-radius: ${props => props.theme.borderRadius};
        padding: 10px;
        margin-bottom:10px;
        font-size: 12px;
        color: #dddddd;
    }

    .stats-history {
        background-color: ${props => props.theme.foregroundColor};
        border-radius: ${props => props.theme.borderRadius};
        padding: 10px;
        font-size: 12px;
        color: #dddddd;
    }
`